import axios from 'axios'

import * as Sentry from '@sentry/vue'
const isProd = process.env.NODE_ENV === 'production'
const baseURL = isProd
  ? process.env.VUE_APP_API_URL_PROD
  : process.env.VUE_APP_API_URL

const ax = axios.create({
  baseURL,
  timeout: 120000,
})

ax.interceptors.request.use(
  config => {
    let token = localStorage.getItem('auth-token')

    if (config.admin) {
      token =
        localStorage.getItem('auth-token') || localStorage.getItem('ceo-token')
    }

    const newConfig = config

    if (token) {
      newConfig.headers.Authorization = `Bearer ${token}`
    }

    return newConfig
  },
  error => {
    if (!(error instanceof Error) && typeof error?.message === 'string') {
      Sentry.captureMessage(error.message)
    } else {
      Sentry.captureException(error)
    }

    return Promise.reject(error)
  },
)

ax.interceptors.response.use(
  res => {
    const version = localStorage.getItem('port-vue-app-version')
    const { vue_app_version } = res.headers

    if (vue_app_version && (!version || vue_app_version !== version)) {
      localStorage.setItem('port-vue-app-version', vue_app_version)

      if (typeof window?.location?.reload === 'function') {
        window.location.reload()
      } else if (typeof document?.location?.reload === 'function') {
        document.location.reload(true)
      }
    }

    return res
  },
  async error => {
    if (error.response && [400, 422].includes(error.response.status)) {
      return Promise.reject(error)
    }

    if (error.response && 401 === error.response.status) {
      localStorage.removeItem('port_user_profile')
      localStorage.removeItem('auth-token')
      localStorage.removeItem('admin-token')
      localStorage.removeItem('ceo-token')

      if (typeof window?.location?.reload === 'function') {
        window.location.reload()
      } else if (typeof document?.location?.reload === 'function') {
        document.location.reload(true)
      }
    } else if (
      !(error instanceof Error) &&
      typeof error?.message === 'string'
    ) {
      Sentry.captureMessage(error?.message)
    } else {
      Sentry.captureException(error)
    }

    return Promise.reject(error.response || error)
  },
)

export default ax
